import { debounce } from "debounce";
import { h } from "hyperapp";
import { onInputChanged } from "./actions/on-input-changed";

export const keywordFilter = ({
  onChanged,
  debounceTime = 450,
  translations,
}: {
  onChanged: ({ keyword, event }: { keyword: string; event?: Event }) => void;
  debounceTime?: number;
  translations;
}): JSX.Element => {
  const onKeyUp = debounce(
    onInputChanged({
      onChanged,
    }),
    debounceTime,
  );

  return (
    <input
      type="text"
      class="form-control"
      placeholder={translations["typeToFilterInResults"]}
      onkeyup={onKeyUp}
    />
  );
};
